import { render, staticRenderFns } from "./PageInfo.vue?vue&type=template&id=26a51438"
import script from "./PageInfo.vue?vue&type=script&lang=ts"
export * from "./PageInfo.vue?vue&type=script&lang=ts"
import style0 from "./PageInfo.vue?vue&type=style&index=0&id=26a51438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports